import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Form, Input, Modal } from "antd";
import { convert } from 'geo-coordinates-parser';
import { txtInputNumericRangeValueValidator, } from "../../../swzutils/FormValidators";
import MapShareVicButton from "./MapShareVicButton";
/* regexes from https://stackoverflow.com/questions/3518504/regular-expression-for-matching-latitude-longitude-coordinates */
const LATITUDE_REGEX = /^([+\-])?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/;
const LONGITUDE_REGEX = /^([+\-])?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/;
// Longitude is East / West (horizontal)
const MIN_LNG = 100; //
const MAX_LNG = 180; // +180 goes to -180 by the international date line
// Latitude is North / South (vertical)
const MIN_LAT = -60;
const MAX_LAT = 0; // 0 is the equator
const LatLngModal = (props) => {
    const [form] = Form.useForm();
    useEffect(() => {
        if (!props.open) {
            form.resetFields();
        }
    }, [props.open]);
    const onOk = () => {
        form.validateFields().then(formValues => {
            props.onSave(parseFloat(formValues.lat), parseFloat(formValues.lng));
        }).catch(errorInfo => { }); // This has to be present otherwise antd crashes :(
    };
    const onPaste = (event) => {
        let val = event.clipboardData.getData('text/plain') || "";
        let sanitisedVal = val.replaceAll(/[^0-9.°SEDM ]/gim, '');
        try {
            let converted = convert(sanitisedVal);
            event.preventDefault();
            form.setFieldsValue({
                lat: converted.decimalLatitude,
                lng: converted.decimalLongitude
            });
        }
        catch {
            /* the string is not valid coordinates or format is inconsistent between lat and long */
        }
    };
    return (_jsxs(Modal, { title: "Latitude/Longitude", open: props.open, onOk: onOk, onCancel: props.onCancel, destroyOnHidden: true, children: [_jsxs(Form, { form: form, layout: "vertical", onFinish: onOk, children: [_jsx(Form.Item, { name: "lat", label: "Latitude", rules: [
                            { required: true, message: 'Please enter latitude' },
                            { pattern: LATITUDE_REGEX, message: 'Invalid latitude' },
                            { validator: txtInputNumericRangeValueValidator(MIN_LAT, MAX_LAT) },
                        ], children: _jsx(Input, { placeholder: "lat", onPaste: onPaste }) }), _jsx(Form.Item, { name: "lng", label: "Longitude", rules: [
                            { required: true, message: 'Please enter longitude' },
                            { pattern: LONGITUDE_REGEX, message: 'Invalid longitude' },
                            { validator: txtInputNumericRangeValueValidator(MIN_LNG, MAX_LNG) },
                        ], children: _jsx(Input, { placeholder: "lng", onPaste: onPaste }) })] }), _jsx(MapShareVicButton, {})] }));
};
export default LatLngModal;
